<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
           <div class="border p-2 mb-3" v-if="quotation.job">
              <div class="row">
                <div class="col-auto">
                  <span class="bg-primary text-white px-3 font-size-26">
                    {{ quotation.job.job_number }}</span
                  >
                </div>
                <div class="col">
                  <p class="text-muted mt-2 mb-0" v-if="quotation.job.manufacture">
                    {{ quotation.job.manufacture.description }} -
                    {{ quotation.job.device_type.description }}
                    <span v-if="quotation.job.device_model">
                      <br />
                      <strong>{{ quotation.job.device_model.code }}</strong> -
                      {{ quotation.job.imei_in ? quotation.job.imei_in : quotation.job.serial_in }}
                    </span>
                  </p>
                </div>
              </div>
            </div>

        <b-tabs>
          <b-tab title="Quote" class="pt-3">

           <b-button variant="outline-info" size="sm" v-if="quotation.device_replacement==1" class="my-2">Device Replacement</b-button>

          <b-badge variant="danger" v-if="quotation.cancelled_at">
            Cancelled  {{
                  moment(new Date(quotation.cancelled_at)).format(
                    "DD MMM YY, HH:mm"
                  )
                }}
          </b-badge>
          <b-badge variant="warning" v-if="quotation.rejected_at">
            Rejected {{
                  moment(new Date(quotation.rejected_at)).format(
                    "DD MMM YY, HH:mm"
                  )
                }}
          </b-badge>
           <b-badge variant="success" v-if="quotation.accepted_at">
            Accepted {{
                  moment(new Date(quotation.accepted_at)).format(
                    "DD MMM YY, HH:mm"
                  )
                }}
          </b-badge>

            <span v-if="quotation.quotation_items">
              <table class="table table-sm border mt-2">
                <tr class="bg-dark text-white font-size-11 font-weight-bold">
                  <td width="20%"> CODE</td>
                  <td width="30%"> DESCRIPTION</td>
                  <td width="14%"> QUANTITY</td>
                  <td width="18%" class="text-right">
                    AMOUNT
                  </td>
                  <td width="18%" class="text-right">
                    TOTAL
                  </td>
                </tr>

                <tr v-for="line in quotation.quotation_items" :key="line.id">
                  <td>
                    {{ line.code }}
                  </td>
                  <td>
                    {{ line.description }}
                  </td>
                   <td>
                    {{ line.quantity }}
                  </td>
                  <td class="text-right">
                    <strong> {{ line.line_amount }}</strong>
                  </td>
                  <td class="text-right">
                    <strong> {{ line.line_total_amount }}</strong>
                  </td>
                </tr>

                <tr>
                  <td class="border-0"></td>
                  <td class="border-0"></td>
                  <td class="border-0"></td>
                  <td class="border-0"></td>
                  <td class="border-0"></td>
                </tr>

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="text-right">SUB TOTAL</td>
                  <td class="text-right">
                    <strong> {{ quotation.sub_total_amount }}</strong>
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td></td>
                   <td></td>
                  <td class="text-right">DISCOUNT</td>
                  <td class="text-right">
                    <strong> {{ quotation.discount_amount }}</strong>
                  </td>
                </tr>

                <tr v-if="quotation.vat_amount">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="text-right">VAT</td>
                  <td class="text-right">
                    <strong>{{ quotation.vat_amount }} </strong>
                  </td>
                </tr>

                <tr>
                  <td colspan="3" class="bg-light"></td>
                  <td class="text-right bg-light lead">
                    <strong>TOTAL DUE</strong>
                  </td>
                  <td class="text-right bg-light lead">
                    <strong>{{ quotation.total_amount }}</strong>
                  </td>
                </tr>

                <tr v-if="quotation.job.is_insurance_job">
                  <td colspan="3" class="bg-light">
                    <span v-if="quotation.job.is_full_cover==0">
                      EXCESS
                      <span v-if="quotation.job.excess_calculation_type=='percentage'">
                        {{quotation.job.excess_percentage }}%
                      </span>
                    </span>
                  </td>
                  <td class="text-right bg-light">
                    <strong>CLIENT</strong>
                  </td>
                  <td class="text-right bg-light ">
                    <strong>{{ quotation.client_amount }}</strong>
                  </td>
                </tr>

                <tr v-if="quotation.job.is_insurance_job">
                  <td colspan="3" class="bg-light">
                    <span v-if="quotation.job.is_full_cover==1">
                      <em>Full Cover</em>
                    </span>
                  </td>
                  <td class="text-right bg-light">
                    <strong>PARTNER</strong>
                  </td>
                  <td class="text-right bg-light">
                    <strong>{{ quotation.partner_amount }}</strong>
                  </td>
                </tr>
              </table>
            </span>

             <!-- <div class="row my-3" v-if="quotation.job && quotation.job.outcome==null && quotation.job.is_repaired==0">
               <div
                    class="col-lg-12 mt-3"
                    v-if="
                      quotation.job &&
                      quotation.job.is_insurance_job == 1 &&
                      quotation.job.excess_payable == 1
                    "
                  >
                    <b-card class="border h-100">
                      <h5>Adjust Split</h5>
                      <form-group label="Client Excess" :required="true">
                        <b-form-radio
                          v-model="quotation.job.excess_calculation_type"
                          name="excessType"
                          value="percentage"
                          @change="quotation.job.excess_amount = null"
                          >% Percentage based</b-form-radio
                        >
                        <b-form-radio
                          v-model="quotation.job.excess_calculation_type"
                          name="excessType"
                          value="amount"
                          @change="quotation.job.excess_percentage = null"
                          > Amount based</b-form-radio
                        >
                      </form-group>

                      <form-group label="Excess" :required="true">
                        <div
                          class="input-group w-50"
                          v-if="
                            quotation.job.excess_calculation_type ==
                            'percentage'
                          "
                        >
                          <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1"
                              >%</span
                            >
                          </div>
                          <input
                            type="number"
                            min="0"
                            class="form-control"
                            @blur="$v.quotation.job.excess_percentage.$touch"
                            :class="{
                              'is-invalid':
                                $v.quotation.job.excess_percentage.$error,
                            }"
                            v-model="quotation.job.excess_percentage"
                          />
                        </div>

                        <input
                          v-if="
                            quotation.job.excess_calculation_type == 'amount'
                          "
                          type="number"
                          min="0"
                          class="form-control w-50"
                          @blur="$v.quotation.job.excess_amount.$touch"
                          :class="{
                            'is-invalid': $v.quotation.job.excess_amount.$error,
                          }"
                          v-model="quotation.job.excess_amount"
                        />
                      </form-group>

                      <form-group label="Device Replacement Price">
                        <input
                          type="number"
                          min="0"
                          class="form-control w-50"
                          v-model="quotation.job.replacement_price"
                        />
                      </form-group>
                        <b-button
                        variant="info"
                        @click="adjust()"
                        >Re-Adjust Quote</b-button>
                    </b-card>
                  </div>
            </div> -->
          </b-tab>

          <b-tab title="Job" class="pt-3" v-if="quotation && quotation.job_id">
            <job-minimal :id="quotation.job_id"></job-minimal>
          </b-tab>
          <b-tab
            title="Client"
            class="pt-3"
            v-if="quotation && quotation.client_id"
          >
            <client-show :id="quotation.client_id"></client-show>
          </b-tab>
          <b-tab
            title="Partner"
            class="pt-3"
            v-if="quotation && quotation.partner_id"
          >
            <partner-show :id="quotation.partner_id"></partner-show>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import quotationRepo from "@/api/repos/quotationRepo";
import jobMinimal from "@/views/modules/jobs/enquiryMinimal";
import clientShow from "@/views/modules/clients/show";
import partnerShow from "@/views/modules/partners/show";
//import tableRow from "@/components/common/TableRow";
//import formGroup from "@/components/common/FormGroup";
import { required, requiredIf } from "vuelidate/lib/validators";

export default {
  props: ["id"],

  components: {
    // tableRow,
    jobMinimal,
    clientShow,
    partnerShow,
  //   formGroup,
  },

  mounted() {
    this.getQuotation();
  },

  data() {
    return {
      loading: false,
      quotation: {},
    };
  },

   validations: {
    quotation: {
      job: {
        excess_calculation_type: {
          required,
        },
        excess_percentage: {
          required: requiredIf(function (job) {
            return job.excess_calculation_type == "percentage";
          }),
        },
        excess_amount: {
          required: requiredIf(function (job) {
            return job.excess_calculation_type == "amount";
          }),
        },
      },
    },
  },

  methods: {
    async getQuotation() {
      try {
        this.loading = true;
        let { data } = await quotationRepo.get(this.id);
        this.quotation = data.quotation;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // async adjust() {
    //   this.loading = true;
    //   this.submitStatus = "PENDING";
    //   this.$v.$touch();
    //   if (this.$v.$invalid) {
    //     this.loading = false;
    //     this.submitStatus = null;
    //   } else {
    //     try {
    //       await quotationRepo.adjust({
    //         id:this.quotation.id,
    //         excess_calculation_type:this.quotation.job.excess_calculation_type,
    //         excess_percentage:this.quotation.job.excess_percentage,
    //         excess_amount:this.quotation.job.excess_amount,
    //         replacement_price:this.quotation.job.replacement_price
    //       });
    //       this.getQuotation()
    //     } catch (error) {
    //       console.log(error);
    //       if (error.response.status === 422) {
    //         this.errors = error.response.data.errors;
    //         console.log(this.errors);
    //         this.$root.$bvToast.toast("Form Errors", {
    //           title: "Errors on form data",
    //           autoHideDelay: 3000,
    //           variant: "danger",
    //         });
    //       }
    //     } finally {
    //       this.loading = false;
    //       this.submitStatus = null;
    //     }
    //   }
    // },
  },
};
</script>
